(function () {
  class WildFireAnim extends PIXI.Container {
    constructor() {
      super();
      this.soundNum = 1;
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    onGameConfigEvent() {
      this.movies = [];
      for (let index = 0; index < 6; index++) {
        const movie = resourceManager.get(
          "slotContainer:reelEffects:wildFireContainer:wildFireAnim:wildFireLand" +
            index
        );
        this.movies.push(movie);
      }
    }

    play(reel) {
      //gameController.shaker.doShake(500);
      const movie = this.movies[reel];
      // if (this.soundNum === 1) {
      //   this.soundNum = 0;
      // } else {
      //   this.soundNum = 1;
      // }
      // soundManager.play(`superWild${this.soundNum}`);
      movie.position = gameController.slotMachine.getSymbolPosition(reel, 1);
      //movie.blendMode = PIXI.BLEND_MODES.NORMAL;
      movie.visible = true;
      movie.gotoAndStop(0);
      movie.onComplete = () => {};
      movie.play();

      timerManager.addTimeout(100, function () {
        gameData.reels[reel].visible = false;
      });
    }

    hideAll() {
      const self = this;
      timerManager.addTimeout(100, function () {
        for (let index = 0; index < self.movies.length; index++) {
          gameData.reels[index].visible = true;
        }
      });
      for (let index = 0; index < this.movies.length; index++) {
        const movie = this.movies[index];
        //gameData.reels[index].visible = true;

        //movie.blendMode = PIXI.BLEND_MODES.ADD;
        gsap.to(movie, {
          duration: 0.4,
          ease: "power1.inOut",
          alpha: 0,
          onComplete: () => {
            movie.alpha = 1;
            movie.visible = false;
            gameData.reels[index].visible = true;
          },
        });
      }
    }
  }

  var wildFireAnimCreator = function (json) {
    return new WildFireAnim();
  };

  var wildFireAnimInitialiser = function (json, wildFireAnim) {};

  var wildFireAnimFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "wildFireAnim",
    wildFireAnimCreator,
    wildFireAnimInitialiser,
    wildFireAnimFilesRequired
  );
})();
